import axiosInstance from "../utils/axios";

export const GetLogDates = async () => {
    return await axiosInstance().post("admin/logs/dates", {});
}

export const GetLogs = async (values) => {
    return await axiosInstance().post("admin/logs/list", values);
}
